import { createFileRoute, redirect } from "@tanstack/react-router";

// Retired feature: send old links somewhere useful. Data is kept.
export const Route = createFileRoute("/schools")({
  beforeLoad: () => {
    throw redirect({ to: "/", replace: true, statusCode: 301 });
  },
});
